import mixpanel from 'mixpanel-browser'

const runtimeConfig = useRuntimeConfig()

const { env, mixpanelToken } = runtimeConfig.public

mixpanel.init(mixpanelToken, {
  debug: env !== 'prod',
  ignore_dnt: true
})

export function useTrack() {
  const track = (eventName: string, data: Record<string, string | number | boolean | null> = {}) => {
    const { company } = useStoreCompany()

    if (!company) return

    mixpanel.track(eventName, {
      ...data,
      company_id: company.id,
      company_name: company.name,
      is_shopify: useStoreStore().isShopify,
      is_connected: useStoreAuth().isAuthenticated
    })
  }

  return { track }
}
